package data

enum class UnsplashPhotoSize { MED, LARGE, XL }

/**
 * Repository for images used in [ui.screens.PhotoGallery]
 */
object UnsplashPhotoData {
    fun getSelfHostedUrl(
        id: String,
        token: String
    ): String {
//        var size = when (targetSize) {
//            UnsplashPhotoSize.MED -> 400
//            UnsplashPhotoSize.LARGE -> 800
//            UnsplashPhotoSize.XL -> 1200
//        }
        // TODO: add high res images
        /*if (platform == Platform.Desktop || platform == Platform.Web) {
            size *= 2
        }*/

        return "https://firebasestorage.googleapis.com/v0/b/the-wedding-of-eva-danu.firebasestorage.app/o/" +
                "DSC_$id.jpg?alt=media&token=$token"
    }

    fun getPhotosByCollectionId(id: String) = photosByCollectionId[id]!!

    private val photosByCollectionId = mapOf(
        "EWkDzLrhpXI" to listOf(
            "234033a7-a921-4293-8fd4-f3fbb9b6ea61",
            "72a735ac-b871-4770-90c3-d9d21c6872fd",
            "9e9a03bb-c474-4183-bde0-a96c9e678c11",
            "d87fbe12-e370-413c-b5f0-a1cc15280cdc",
            "73d207b6-d61d-47dd-bada-7aa80c2c82d3",
            "d2bc3a2f-170f-4b82-a311-dae97c88f908",
            "6361997e-ffe7-4ac6-b222-bdeefaebedaf",
            "38ba2aaa-6f5a-41b8-ba58-99768d9b8e5b",
            "87caf0cc-0844-4f13-ad88-07e2aa98393e"
        ),
        "684IRta86_c" to listOf(
            "7912", "7915", "7938",
            "7951", "7911", "7954",
            "7979", "7957", "7984"
        ),
        "dPgX5iK8Ufo" to listOf(
            "0jcM54HBO4c", "fcaeEfnh818", "bQFxKVLV6SY", "eTIG213bO4U",
            "8yYYyxdcyrY", "zeH77USuASc", "okvoZRLXOsw", "21AiwkRfAnY",
            "-e0u9SAFeP4", "BVj6AnXs3TA", "d2kxugivOJo", "RSvKa3Jg3Z8",
            "cG2JQnPfmAw", "o-bc8wuY29c", "xec7srO4U5c", "4nJOD8wtMS4",
            "JoJuM-n20zo", "CErddu-JwKw", "GTLJklnjn-E", "DSm50vbc9F0",
            "ka-HD2cZYec", "8tTh9isJoos", "OkiDIla7K8Q", "xaIEq6owYvM"
        ),
        "VPdti8Kjq9o" to listOf(
            "rhRk8J33Bcc", "INA89gCRuNo", "K-TOsIh8FxE", "grlIoctRp1o",
            "mCLvY_GsdW8", "GHA2X73SRL8", "BLGigyFXbPo", "j-1UlgFdpx8",
            "iIINwmkBizU", "PWdWPYF0_RY", "kdlTfNzJBx0", "LUdSrJw-BII",
            "3mzn2xpA2YA", "nAb-SFzL1GM", "s87bBFZviAU", "sKYsYzEG2Lg",
            "3b4e9D731ME", "haLyuhP6oLE", "lUO-BjCiZEA", "TWOrGJ5REuY",
            "VFRTXGw1VjU", "ckotRXopwRM", "CzKI2-nejUk", "Q4g0Q-eVVEg"
        ),
        "Kg_h04xvZEo" to listOf(
            "eq4OpDuGN7w", "cSKa2PDcU-Q", "MLfwSItwSpg", "1xnuIi-zcTQ",
            "20Nfb3kTnsY", "Wbu_scb-9HQ", "0FMRVVrMCyc", "Q36BvLGdOAg",
            "RyGG5z6SUZ8", "ZQxxar2ovS0", "siy5LCp84AY", "chc2vP_7_kY",
            "i56swU7BDbQ", "6aZBfbzx5Ms", "VW8YW3Xlc0k", "MZayf0ZVY-A",
            "fDxfe1_5VyY", "E13mcj-2TLE", "sGPfjjAOX1o", "d0VxLuvjUJA",
            "lzwT4n05p20", "OXL47qN9brQ", "vhKZvNFmpPU", "2s1chnvuMQ4"
        ),
        "wUhgZTyUnl8" to listOf(
            "UiUtIG0xLPM", "qytSCIVTTc4", "Ewm_GNF15E4", "Tzooq3pm5P8",
            "laNV6F7Sk3M", "kNbq1SHfLd8", "aqWoohHDRYw", "bLxbRF-CFrU",
            "WMkuiKU6uBM", "yam1KMv0SgQ", "VddWWTaTnpQ", "oDZyswNe6jg",
            "Tpo2Fq8BtCk", "e83VIgq_hgI", "Q_OTD6Hs56c", "EKNe678ktEY",
            "t1HTTqB2TtE", "bPfIUoXX_X4", "3NWi-SGUjHA", "oKvTO3WdxKY",
            "PO7CGnoDFUI", "7bBaW4UPk7A", "iyYMqhLwDQE", "BtYpDZNIeFc"
        ),
        "qWQJbDvCMW8" to listOf(
            "I4PEltFE6v8", "5JHj33-s604", "gKn3GCu55W4", "1MglIsDOypY",
            "pvOzKAmMtaU", "EfWHX2plrww", "cXnisQvxpbU", "z5cCf20gOE8",
            "AVgjb2KpWr4", "ucGxk8JLmWw", "_-X-y-NaQNs", "eVD08ZVuJmY",
            "QNJdCsluIoI", "irUJJCORE1c", "FgYSaefAUTs", "OdDzYng7lTI",
            "Un067U25aOc", "iYPIx7VIh5g", "Ivwyqtw3PzU", "c8F1hJ_UTrk",
            "Pm1hCH1X2r0", "sYMgkKkHpGI", "5_Bu25SV6X8", "py8omnp-hko"
        ),
        "CSEvB5Tza9E" to listOf(
            "-tnS9O1ubn8", "CxXpMYIk_64", "IBILLYRAW1o", "tjjrLV2x0-I",
            "YWbQKxSwMtE", "QxPNDh0_5EQ", "bylApKzvY3g", "oCkZ6WicY8Q",
            "H3ugdzHeh2I", "Mkh6SOuL-Z0", "TY7b_S4mLwk", "MmoaflYGwuI",
            "27a_s3DdbVc", "Y4QPolVdgx8", "J0Z37Hx5f-I", "f3hx6y0NzrQ",
            "IYKL2uhgsnU", "M66ux8WJ-9M", "FXXuJ9S-KkQ", "zRacUCRY_Sw",
            "boyXZfqpwpU", "rxv2qwYPe6s", "zpAwgjaI3lI", "MoonoldXeqs"
        )
    )
}

